var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "detail-panel",
    transform: "translate(-17.000000, -133.000000)",
    fill: "#0091EA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-number",
    transform: "translate(17.000000, 130.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.21777778,9.92444444 C4.49777778,12.44 6.56,14.4933333 9.07555556,15.7822222 L11.0311111,13.8266667 C11.2711111,13.5866667 11.6266667,13.5066667 11.9377778,13.6133333 C12.9333333,13.9422222 14.0088889,14.12 15.1111111,14.12 C15.6,14.12 16,14.52 16,15.0088889 L16,18.1111111 C16,18.6 15.6,19 15.1111111,19 C6.76444444,19 0,12.2355556 0,3.88888889 C0,3.4 0.4,3 0.888888889,3 L4,3 C4.48888889,3 4.88888889,3.4 4.88888889,3.88888889 C4.88888889,5 5.06666667,6.06666667 5.39555556,7.06222222 C5.49333333,7.37333333 5.42222222,7.72 5.17333333,7.96888889 L3.21777778,9.92444444 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.80d2539f4786bc28430ad48183b74470.svg";
export { ForwardRef as ReactComponent };